import {BaseCartController} from '../../domain/controllers/BaseCartController';
import {CART_ORIGIN} from '../../common/constants';
import {defaultStyles} from './defaultStyles';
import {getFreeTextKeys} from './settingsParams';
import {wixcodePublicApi} from './WixCode/wixcodePublicApi';
import {ICartStyleSettings} from '../../types/app.types';

export class CartController extends BaseCartController {
  protected getOrigin() {
    return CART_ORIGIN;
  }
  protected getDefaultSettings(): ICartStyleSettings {
    return defaultStyles;
  }

  public exports = () => wixcodePublicApi(this.siteStore.experiments, this.setVeloInputs);

  public getFreeTexts(): string[] {
    return getFreeTextKeys();
  }
}
